export default "__VITE_ASSET__3a8a94a2__"